// @flow

export default Object.freeze({
  GET_CONTACT_METRICS_BY_SERVICE_PROVIDER: 'office-app/GET_CONTACT_METRICS_BY_SERVICE_PROVIDER',
  GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_ERROR: 'office-app/GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_ERROR',
  GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_START: 'office-app/GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_START',
  GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_SUCCESS: 'office-app/GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_SUCCESS',
  GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_RESET: 'office-app/GET_CONTACT_METRICS_BY_SERVICE_PROVIDER_RESET',

  GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER: 'office-app/GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER',
  GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_ERROR: 'office-app/GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_ERROR',
  GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_START: 'office-app/GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_START',
  GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_SUCCESS: 'office-app/GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_SUCCESS',
  GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_RESET: 'office-app/GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER_RESET',

  GET_CALL_LOG_BY_SERVICE_PROVIDER: 'office-app/GET_CALL_LOG_BY_SERVICE_PROVIDER',
  GET_CALL_LOG_BY_SERVICE_PROVIDER_ERROR: 'office-app/GET_CALL_LOG_BY_SERVICE_PROVIDER_ERROR',
  GET_CALL_LOG_BY_SERVICE_PROVIDER_START: 'office-app/GET_CALL_LOG_BY_SERVICE_PROVIDER_START',
  GET_CALL_LOG_BY_SERVICE_PROVIDER_SUCCESS: 'office-app/GET_CALL_LOG_BY_SERVICE_PROVIDER_SUCCESS',
  GET_CALL_LOG_BY_SERVICE_PROVIDER_RESET: 'office-app/GET_CALL_LOG_BY_SERVICE_PROVIDER_RESET',

  GET_CUSTOMER_ATTRIBUTES_BY_UUID: 'office-app/GET_CUSTOMER_ATTRIBUTES_BY_UUID',
  GET_CUSTOMER_ATTRIBUTES_BY_UUID_ERROR: 'office-app/GET_CUSTOMER_ATTRIBUTES_BY_UUID_ERROR',
  GET_CUSTOMER_ATTRIBUTES_BY_UUID_START: 'office-app/GET_CUSTOMER_ATTRIBUTES_BY_UUID_START',
  GET_CUSTOMER_ATTRIBUTES_BY_UUID_SUCCESS: 'office-app/GET_CUSTOMER_ATTRIBUTES_BY_UUID_SUCCESS',
  GET_CUSTOMER_ATTRIBUTES_BY_UUID_RESET: 'office-app/GET_CUSTOMER_ATTRIBUTES_BY_UUID_RESET',
});



// WEBPACK FOOTER //
// ./src/modules/home/common/performanceActionKeys.js